import { IconOptions } from '@/types'

type Social = {
  id: IconOptions
  label: string
  url: string
}

export const social: Social[] = [
  {
    id: 'fb',
    label: 'Facebook',
    url: 'https://www.facebook.com/GUCCI/'
  },
  {
    id: 'ig',
    label: 'Instagram',
    url: 'https://www.instagram.com/gucci/'
  }
]
